import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
const imageSchema = Joi.object({
  type: Joi.string().allow('', null),
  code: Joi.string().allow('', null),
  image: mediaUrlSchema,
  blur: mediaUrlSchema,
  images: mediaUrlSchema,
  title: Joi.string().allow('', null),
  alt: Joi.string().allow('', null)
}).unknown(true);
export default imageSchema;